import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const campusImages = [
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/10c8620570e3d0bb2aa72c508a192d7f4e0add66dc2ab10a465bd3ca17320d7f.png",
    name: "IIT Bombay"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/dc7c0f2d17aa122c0977433d99c6effc18d155b4dcab1e5d81d491f237ba7578.png",
    name: "IIT Delhi"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/0e7c732b2d13a78066a763a6351d4701a1212ba8366e2852f8b100aae3c0c004.png",
    name: "IIT Madras"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/9e41d9d27335ac382a7a59d801d4c66a7b4d7e3d0a1cd6776b47ffbbda301b26.png",
    name: "IIT Kanpur"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/02638a26e3b5ac1de807221edef7ac242d001d788c68ed25db33537b732e00fb.png",
    name: "IIM Ahmedabad"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/d353953d452efe8f0e04e3f5af2c039f26400930a6b909377981a6f7304563d6.png",
    name: "IIM Bangalore"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/62f558f2e473c9cb11778726a7006d2952a6deb3f7bd3bed1b21e4440f8f6f01.png",
    name: "IIM Calcutta"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/2bd727b8164810af624f260296621c322a716b479f7b3cca7c33b30f31710109.png",
    name: "BITS Pilani"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/a2eee39daf7746d9cdc071b3e39998a3fa780d8e6e94924432596f1ce8f12a87.png",
    name: "ISB Hyderabad"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/d12646e2-c018-4caf-8c2e-8fae168b096f/images/40615895fb49339dc03fd5e5570bb07c18b5fe3f76eb9b44f08ff9208054a507.png",
    name: "Delhi University"
  }
];

const slideVariants = {
  enter: {
    x: "100%",
  },
  center: {
    x: 0,
  },
  exit: {
    x: "-100%",
  },
};

const CampusCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % campusImages.length);
    }, 5000); // 5 seconds per image
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative aspect-[4/3] lg:aspect-auto lg:h-[400px] overflow-hidden rounded-3xl shadow-2xl bg-black">
      <AnimatePresence initial={false} mode="popLayout">
        <motion.div
          key={currentIndex}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="absolute inset-0"
        >
          <img 
            src={campusImages[currentIndex].url}
            alt={campusImages[currentIndex].name}
            className="w-full h-full object-cover"
          />
          {/* Gradient overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          
          {/* College name in bottom left */}
          <div className="absolute bottom-4 left-4">
            <span className="text-white/90 text-sm font-medium tracking-wide">
              {campusImages[currentIndex].name}
            </span>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default CampusCarousel;
